import { FlowerIcon } from './FlowerIcon';

/**
 * author: Google
 * id D73BB486-A112-48C1-A4EE-993825164C43
 * name flower
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flower.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const LocalFloristIcon = FlowerIcon;
export default LocalFloristIcon